var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrowSelectAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1.38015 8.32392L1.34573 8.18415C1.2915 7.96482 1.43907 7.816 2.22683 7.04865C2.61782 6.6676 3.10431 6.19341 3.4927 5.75141L3.51467 5.72907C3.77621 5.496 4.01604 5.23011 4.20901 5.01594C4.35774 4.85024 4.48584 4.70941 4.58865 4.6175L4.66799 4.57856C4.35923 4.27486 3.90267 3.83893 3.42214 3.38056C1.28835 1.34501 1.28303 1.32819 1.32058 1.13837L1.38674 0.951484L1.52639 0.917549C1.74508 0.863974 1.90708 1.02248 2.7283 1.87324C3.13562 2.29508 3.64203 2.81964 4.13064 3.26008C4.38661 3.54018 4.67546 3.80186 4.90798 4.01215C5.07894 4.16731 5.22557 4.30058 5.324 4.40656L5.39089 4.52912L5.39187 4.62641L5.38577 4.7945L5.25955 4.86787C5.23296 4.88356 5.19889 4.8972 5.15847 4.90168L5.16335 4.91303L5.05105 5.03352C4.51167 5.61205 3.91377 6.22821 3.16921 6.97175C2.70455 7.43921 2.23904 7.88466 1.78054 8.32221L1.67507 8.42316L1.38015 8.32392Z",
    fill: "#18376D",
    stroke: "#18376D",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowSelectAll);
export default __webpack_public_path__ + "static/media/right-arrow-select-all.ff178448a6305981906ded2a3f7e0f68.svg";
export { ForwardRef as ReactComponent };